export default {
  transportOrderList: {
    search: {
      deliveryNo: '物流运输单号',
      deliveryNoPlaceholder: '请输入物流运输单号',
      instructionNo: '发货指令号',
      instructionNoPlaceholder: '请输入发货指令号',
      salesLadingNo: '销售提单号',
      salesLadingNoPlaceholder: '请输入销售提单号',
      transferSlipNo: '库存调拨单号',
      transferSlipNoPlaceholder: '请输入库存调拨单号',
      otherNo: '其他单号',
      otherNoPlaceholder: '请输入其他单号',
      deliveryProductName: '商品',
      deliveryProductNamePlaceholder: '请选择商品',
      startDeliveryStartDate: '起运日期起',
      startDeliveryStartDatePlaceholder: '请选择起运日期开始时间',
      endDeliveryStartDate: '起运日期止',
      endDeliveryStartDatePlaceholder: '请选择起运日期结束时间',
      carrierName: '承运方',
      carrierNamePlaceholder: '请选择承运方',
      pickupStorageName: '提货仓库',
      pickupStorageNamePlaceholder: '请选择提货仓库',
      shiptoStorageName: '收货仓库',
      shiptoStorageNamePlaceholder: '请选择收货仓库',
      warehouseAddress: '仓库地址',
      warehouseAddressPlaceholder: '请输入仓库地址',
      deliveryContactPerson: '运输联系人',
      deliveryContactPersonPlaceholder: '请输入运输联系人',
      pickupStorageAddress: '提货仓库地址',
      pickupStorageAddressPlaceholder: '请输入提货仓库地址',
      shiptoStorageAddress: '送达仓库地址',
      shiptoStorageAddressPlaceholder: '请输入送达仓库地址',
      deliveryDepartment: '部门',
      deliveryDepartmentPlaceholder: '请选择部门',
      departmentName: '部门名称',
      departmentNamePlaceholder: '请输入部门名称',
      salesmanName: '业务员',
      salesmanNamePlaceholder: '请选择业务员',
      staffName: '人员名称',
      staffNamePlaceholder: '请输入人员名称',
      deliveryStatus: '状态',
      deliveryStatusPlaceholder: '请选择状态',
      deliveryType: '运输单类型',
      deliveryTypePlaceholder: '请选择运输单类型',
    },
    table: {
      deliveryNo: '物流运输单号',
      deliveryStatus: '状态',
      deliveryType: '运输单类型',
      instructionNo: '发货指令号',
      salesLadingNo: '销售提单号',
      transferSlipNo: '库存调拨单号',
      otherNo: '其他单号',
      deliveryStartDate: '起运日期',
      deliveryProductName: '商品描述',
      deliveryQuantity: '数量',
      carrierName: '承运方',
      pickupStorageName: '提货仓库',
      shiptoStorageName: '收货仓库',
      deliveryContactPerson: '运输联系人',
      deliveryContactTelephone: '运输联系方式',
      pickupStorageAddress: '提货仓库地址',
      shiptoStorageAddress: '送达仓库地址',
      deliveryExpenseUnitPrice: '运费单价（元/吨)',
      otherExpense: '其他费用',
      salesmanName: '业务员',
      deliveryDepartment: '部门',
      shiptoDemand: '送货要求',
    },
  },
  transportOrderAdd: {
    msg: {
      updateSusscess: '修改成功！',
      saveSussess: '新增成功！',
      success: '成功！',
      error: '失败！',
      comfirmSusscess: '确认成功！',
    },
    path: {
      addPathName: '物流运输单创建',
      listPathName: '物流运输单查询',
      editPathName: '物流运输单',
    },
    btnList: {
      save: '保存',
      confirm: '确认',
      invalid: '作废',
      undo: '撤销',
      print: '打印',
      add: '新增',
      remove: '删除',
    },
    collapseTitle: {
      topTitle: '物流运输单',
      baseTitle: '基本信息',
      pickUpTitle: '提货信息',
      deliveryTitle: '送达信息',
      transportTitle: '运输信息',
      goodsTitle: '商品信息',
    },
    topForm: {
      deliveryNo: '物流运输单号',
      deliveryNoPlaceholder: '请输入物流运输单号',
      deliveryCreatePersonName: '制单人',
      deliveryCreatePersonNamePlaceholder: '请输入制单人',
      deliveryCreateDate: '制单日期',
      deliveryCreateDatePlaceholder: '请选择制单日期',
      deliveryStatus: '物流运输单状态',
      deliveryStatusPlaceholder: '请选择物流运输单状态',
      deliveryLoginCompany: '公司',
      deliveryLoginCompanyPlaceholder: '请输入公司',
      deliveryType: '运输单类型',
      deliveryTypePlaceholder: '请选择运输单类型',
    },
    baseForm: {
      instructionNo: '发货指令号',
      instructionNoPlaceholder: '请输入发货指令号',
      salesLadingNo: '销售提单号',
      salesLadingNoPlaceholder: '请输入销售提单号',
      transferSlipNo: '库存调拨单号',
      transferSlipNoPlaceholder: '请输入库存调拨单号',
      otherNo: '其他单号',
      otherNoPlaceholder: '请输入其他单号',
      pickupNo: '提货单号',
      pickupNoPlaceholder: '请输入提货单号',
      providerName: '供应商',
      providerNamePlaceholder: '请输入供应商',
      salesmanName: '业务员',
      salesmanNamePlaceholder: '请输入业务员',
      deliveryDepartment: '部门',
      deliveryDepartmentPlaceholder: '请输入部门',
      customerName: '客户',
      customerNamePlaceholder: '请输入客户',
    },
    pickUpForm: {
      deliveryStartDate: '起运日期',
      deliveryStartDatePlaceholder: '请选择起运日期',
      pickupStorageName: '提货仓库',
      pickupStorageNamePlaceholder: '请输入提货仓库',
      pickupStorageAddress: '仓库地址',
      pickupStorageAddressPlaceholder: '请输入仓库地址',
      pickupContactPerson: '提货联系人',
      pickupContactPersonPlaceholder: '请输入提货联系人',
      pickupContactTelephone: '联系方式',
      pickupContactTelephonePlaceholder: '请输入联系方式',
      pickupStorageTelephone: '仓库电话',
      pickupStorageTelephonePlaceholder: '请输入仓库电话',
      pickupEntity: '提货单位',
      pickupEntityPlaceholder: '请输入提货单位',
      pickupStorageArea: '仓库区域',
      pickupStorageAreaPlaceholder: '请输入仓库区域',
      pickupMark: '提货备注',
      pickupMarkPlaceholder: '请输入提货备注',
    },
    deliveryForm: {
      shiptoStorageName: '收货仓库',
      shiptoStorageNamePlaceholder: '请输入收货仓库',
      shiptoFlow: '流向',
      shiptoFlowPlaceholder: '请输入流向',
      shiptoStorageAddress: '仓库地址',
      shiptoStorageAddressPlaceholder: '请输入仓库地址',
      shiptoContactPerson: '收货联系人',
      shiptoContactPersonPlaceholder: '请输入收货联系人',
      shiptoContactTelephone: '联系方式',
      shiptoContactTelephonePlaceholder: '请输入联系方式',
      shiptoStorageTelephone: '仓库电话',
      shiptoStorageTelephonePlaceholder: '请输入仓库电话',
      shiptoStorageArea: '仓库区域',
      shiptoStorageAreaPlaceholder: '请输入仓库区域',
      shiptoEntity: '送达单位',
      shiptoEntityPlaceholder: '请输入送达单位',
      shiptoDemand: '送货要求',
      shiptoDemandPlaceholder: '请输入送货要求',
      shiptoMark: '送达备注',
      shiptoMarkPlaceholder: '请输入送达备注',
    },
    transportForm: {
      carrierName: '承运方',
      carrierNamePlaceholder: '请选择承运方',
      deliveryProductNo: '商品',
      deliveryProductNoPlaceholder: '请输入商品',
      deliveryContactPerson: '运输联系人',
      deliveryContactPersonPlaceholder: '请输入运输联系人',
      deliveryContactTelephone: '运输联系方式',
      deliveryContactTelephonePlaceholder: '请输入运输联系方式',
      deliveryQuantity: '运输数量',
      deliveryQuantityPlaceholder: '请输入运输数量',
      deliveryPackageNumber: '运输件数',
      deliveryPackageNumberPlaceholder: '请输入运输件数',
      deliveryExpenseUnitPrice: '运费单价',
      deliveryExpenseUnitPricePlaceholder: '请输入运费单价',
      deliveryExpenseUnit: '运费单位',
      deliveryExpenseUnitPlaceholder: '请输入运费单位',
      deliveryExpenseTotalPrice: '运费总价',
      deliveryExpenseTotalPricePlaceholder: '请输入运费总价',
      otherExpense: '其他费用',
      otherExpensePlaceholder: '请输入其他费用',
      otherExpenseType: '其他费用类型',
      otherExpenseTypePlaceholder: '请选择其他费用类型',
      totalExpense: '费用合计',
      totalExpensePlaceholder: '请输入费用合计',
      deliveryMethod: '运输方式',
      deliveryMethodPlaceholder: '请选择运输方式',
      settle: '结算标识',
      expenseMark: '费用备注',
      expenseMarkPlaceholder: '请输入费用备注',
    },
    transTable: {
      transNum: '船名/航次/车牌',
      freightInfo: '货运信息',
      linkMan: '联系人',
      contactWay: '联系方式',
      idNumber: '身份证号',
    },
    transTableRules: {
      nameVoyageLicense: '请输入船名/航次/车牌',
      freightInformation: '请输入货运信息',
      contactPerson: '请输入联系人',
      contactPhoneNo: '请输入联系方式',
      identityCardNumber: '请输入身份证号',
    },
    goodsTable: {
      deliveryDetailNo: '序号',
      instructionNo: '发货指令行项目号',
      salesLadingNo: '销售提单行项目号',
      transferSlipNo: '库存调拨行项目号',
      otherNo: '其他行项目号',
      providerName: '供应商',
      productNo: '商品编号',
      productName: '商品名称',
      deliveryQuantity: '数量',
      contractUnit: '单位',
      packageNumber: '件数',
      packageUnit: '件数单位',
      mark: '备注',
    },
  },
};
